// extracted by mini-css-extract-plugin
export default {"item":"Card_item__ykNCY","item_no_padding":"Card_item_no_padding__Xr2h5","column":"Card_column__Ouj0H","column_perma":"Card_column_perma__oVOlM"};